import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';
import {
  scheduleConversationReadUiSync,
  beginConversationReadUiSync,
  cancelConversationReadUiSync,
  MESSAGE_READ_UI_SYNC_DELAY_MS,
} from 'dashboard/helper/conversationReadSync';

export default {
  markMessagesRead: async ({ commit, dispatch, state }, data) => {
    let hadUnreadMessages = false;

    try {
      const conversation = state.allConversations.find(
        item => item.id === data.id
      );
      hadUnreadMessages = Number(conversation?.unread_count) > 0;

      if (hadUnreadMessages) {
        beginConversationReadUiSync();
      }

      const {
        data: { id, agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessageRead(data);

      const applyReadState = () => {
        commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
          id,
          lastSeen,
          unreadCount,
        });
      };

      if (hadUnreadMessages) {
        scheduleConversationReadUiSync(() => {
          applyReadState();

          if (Number(unreadCount) === 0) {
            dispatch('conversationUnreadCounts/get', {}, { root: true });
          }
        });
        return;
      }

      setTimeout(applyReadState, MESSAGE_READ_UI_SYNC_DELAY_MS);
    } catch (error) {
      if (hadUnreadMessages) {
        cancelConversationReadUiSync();
      }
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
